import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { PriceMatrixItemModel } from './typings/price-matrix.item';
import { Table }                from '../table/types/table';

@Component({
  selector   : 'wor-price-matrix-add-group',
  template: require('./price-matrix.add-group.component.html')
})
export class PriceMatrixAddGroupComponent {
  @Input() groups: Array<PriceMatrixItemModel>;

  selectedGroups: Array<PriceMatrixItemModel> = [];

  tableSettings: Table = {
    columns: [
      {
        classes: 'text-left',
        field  : 'name',
        header : {
          text: this.translateService.instant('PRODUCT_SPACE.PRODUCT_GROUP')
        }
      },
      {
        classes: 'text-left',
        field  : 'description',
        header : {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PRODUCT_GROUPS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true,
        multi  : true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  constructor (
    public  activeModal     : NgbActiveModal,
    private translateService: TranslateService
  ) {}

  add () : void {
    this.activeModal.close(this.selectedGroups);
  }

  select ( row ?: any ) : void {
    this.selectedGroups = this.groups.filter(( group : PriceMatrixItemModel ) => group.selected);
  }

  selectNone () : void {
    this.selectedGroups.forEach(( group : PriceMatrixItemModel ) => {
      group.selected = false;
    });

    this.select();
  }
}
